export default __webpack_public_path__ + "static/media/er.25da9aef.svg";